/**
 * User field helpers.
 *
 * formatPhoneNumberForDisplay renders an E.164-style number ("+1XXXXXXXXXX")
 * as "+1 (XXX) XXX-XXXX", returning the input unchanged if it doesn't match;
 * validateEmail is a simple regex email check. Used by InputField and the
 * VerifyEmail page.
 */
export function formatPhoneNumberForDisplay(phoneNumber: string): string {
    // Regular expression to match the phone number parts
    const match = phoneNumber.match(/^\+(\d)(\d{3})(\d{3})(\d{4})$/);

    if (match) {
        const countryCode = match[1];
        const areaCode = match[2];
        const firstPart = match[3];
        const secondPart = match[4];

        // Format the phone number
        return `+${countryCode} (${areaCode}) ${firstPart}-${secondPart}`;
    }

    // Return the original phone number if it doesn't match the expected format
    return phoneNumber;
}

export const validateEmail = (email: string) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
};
